module.exports = __webpack_public_path__ + "templates.dialog.member_point_rule-91fd514a.html";